var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionReportIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3484 19.235C16.8291 19.235 18.034 18.03 18.034 16.5487V3.45898C18.034 1.97837 16.8291 0.773438 15.3484 0.773438H4.65283C3.17221 0.773438 1.96729 1.97837 1.96729 3.45898V16.5487C1.96729 18.03 3.17221 19.235 4.65283 19.235H15.3484ZM3.50575 16.5487V3.45898C3.50575 2.82647 4.02032 2.3119 4.65283 2.3119H15.3484C15.981 2.3119 16.4955 2.82647 16.4955 3.45898V16.5487C16.4955 17.1819 15.981 17.6965 15.3484 17.6965H4.65283C4.02032 17.6965 3.50575 17.1819 3.50575 16.5487Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96304 14.4062H6.56611C6.14093 14.4062 5.79688 14.7503 5.79688 15.1755C5.79688 15.6007 6.14093 15.9447 6.56611 15.9447H9.96304C10.3882 15.9447 10.7323 15.6007 10.7323 15.1755C10.7323 14.7503 10.3882 14.4062 9.96304 14.4062Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4351 10.7344H6.56611C6.14093 10.7344 5.79688 11.0784 5.79688 11.5036C5.79688 11.9288 6.14093 12.2728 6.56611 12.2728H13.4351C13.8603 12.2728 14.2043 11.9288 14.2043 11.5036C14.2043 11.0784 13.8603 10.7344 13.4351 10.7344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67293 8.72354L8.60802 6.70431L11.0029 8.23075C11.3176 8.43207 11.7368 8.37573 11.9884 8.09553L14.4561 5.34538C14.7401 5.02913 14.7138 4.5431 14.3975 4.25915C14.082 3.97519 13.596 4.00224 13.3113 4.31774L11.2793 6.58261L8.9025 5.06744C8.5945 4.87288 8.18885 4.91945 7.9342 5.18388L5.56265 7.65834C5.26818 7.96558 5.2787 8.45236 5.58519 8.74608C5.89087 9.03947 6.37753 9.0307 6.67293 8.72354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionReportIcons);
export default __webpack_public_path__ + "static/media/SubscriptionReportIcons.0fb5a2cf0d92ebf86620a5b12f240e72.svg";
export { ForwardRef as ReactComponent };